import { Button } from '@cloudflare/kumo';
import { CaretRight } from '@phosphor-icons/react';
import { useId } from 'react';
import { MarkdownView } from '../common.tsx';

export function Thoughts({
  summary,
  open,
  onToggle,
}: {
  summary: { type: 'summary_text'; text: string }[];
  open: boolean;
  onToggle: () => void;
}) {
  const id = useId();
  const latestText = summary.at(-1)?.text ?? '';
  const paragraphs = latestText.trim().split(/\n\s*\n/);
  const heading = summary
    .map((part) => part.text.match(/^\s*(\*\*[^\r\n]+\*\*|#{1,6} [^\r\n]+)(?:\r?\n[ \t]*\r?\n|$)/))
    .findLast((match) => match !== null);
  const title = heading?.[1]?.replace(/^\*\*|\*\*$/g, '').replace(/^#{1,6} /, '');
  const preview = paragraphs.at(-1)?.replace(/\s+/g, ' ');
  return (
    <div
      className={`chat-thoughts min-w-0 text-kumo-subtle [&+.chat-assistant]:pt-1 ${open ? 'mb-2' : 'mb-1'}`}
    >
      <Button
        type="button"
        variant="ghost"
        size="sm"
        aria-expanded={open}
        aria-controls={id}
        onClick={onToggle}
        className="h-auto min-h-0 w-fit max-w-full min-w-0 justify-start gap-2 px-0 py-0.5 text-left text-[13px] text-kumo-subtle hover:bg-transparent hover:text-kumo-default"
      >
        <span className="min-w-0 truncate">{title ?? 'Thoughts'}</span>
        {!title && <span className="min-w-0 truncate font-normal">{preview}</span>}
        <CaretRight aria-hidden="true" className={`shrink-0 ${open ? 'rotate-90' : ''}`} size={14} />
      </Button>
      <div
        id={id}
        hidden={!open}
        className="mt-2 border-l border-kumo-line pl-3 wrap-anywhere [&_.prose]:text-[13px]"
      >
        <MarkdownView value={summary.map((part) => part.text).join('\n\n')} />
      </div>
    </div>
  );
}
